import { useUserPermissions } from '../../../pages/company/userPermissions'

export const useCanEditPosition = (): boolean => {
  const { edit } = useUserPermissions()
  return edit
}
